import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await axios.get(`https://whats-app.360websitedemo.com/api/verify/${token}`);
                setMessage(response.data.message);
                // Store the JWT token in local storage
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                }
                // Redirect to dashboard after 2 seconds
                setTimeout(() => {
                    navigate('/dashboard');
                }, 2000);
            } catch (err) {
                setError(err.response?.data?.error || 'Failed to verify email');
            }
        };

        verifyEmail();
    }, [token, navigate]);

    return (
        <div className="min-h-screen flex">
            {/* Left Panel */}
            <div className="w-1/2 bg-green-700 flex items-center justify-center">
                <h1 className="text-4xl font-bold text-white">WhatsApp Sender</h1>
            </div>
            {/* Right Panel */}
            <div className="w-1/2 flex items-center justify-center bg-white">
                <div className="w-full max-w-md p-8">
                    <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Email Verification</h2>
                    {message && (
                        <div className="mb-4 p-4 bg-green-100 text-green-700 rounded">
                            {message}
                        </div>
                    )}
                    {error && (
                        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;